import { ArrowRight, Calendar, Clock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { allBlogArticles } from "@/data/blogArticles";

const FeaturedBlogs = () => {
  const navigate = useNavigate();

  // Show only first 4 featured blogs on homepage
  const featuredBlogs = allBlogArticles.slice(0, 4);

  const handleArticleClick = (articleId) => {
    navigate(`/blog/${articleId}`);
  };

  const viewAllBlogs = () => {
    navigate('/blog/all');
  };

  return (
    <section className="py-16 md:py-24 px-4 bg-white" data-testid="featured-blogs-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Latest Insights & Guides
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Expert tips and comprehensive guides to help you succeed on every platform
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8">
          {featuredBlogs.map((article, idx) => (
            <article 
              key={idx} 
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden cursor-pointer transform hover:scale-105 border border-gray-100"
              onClick={() => handleArticleClick(article.id)}
              data-testid={`featured-article-${idx}`}
            >
              {/* Blog Image */}
              <div className="relative h-56 bg-gray-200 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-red-500 text-white px-4 py-1 rounded-full text-sm font-semibold">
                    {article.category}
                  </span>
                </div>
              </div>

              {/* Blog Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 hover:text-red-500 transition line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                  <div className="flex items-center gap-2">
                    <Calendar size={16} />
                    <span>{article.date}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Clock size={16} />
                    <span>{article.readTime}</span>
                  </div>
                </div>
                <button className="text-red-500 font-semibold flex items-center gap-2 hover:gap-3 transition-all">
                  Read More <ArrowRight size={16} />
                </button>
              </div>
            </article>
          ))}
        </div>

        {/* View All Blogs CTA */}
        <div className="mt-12 text-center">
          <button
            onClick={viewAllBlogs}
            className="bg-gradient-to-r from-red-500 to-red-600 text-white px-8 py-4 rounded-full hover:shadow-2xl transition-all duration-300 transform hover:scale-105 font-semibold text-lg inline-flex items-center gap-2"
          >
            View All 50+ Articles <ArrowRight size={20} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default FeaturedBlogs;